import apiConfig from "../../config/apiConfig";
import { toastType } from "../../constants";
import { addToast } from "./toastAction";
import { setLoading } from "./loadingAction";

export const transactionExcelAction =
    (filter = {}, isLoading = true) =>
        async (dispatch) => {
            if (isLoading) {
                dispatch(setLoading(true));
            }

            let url = `b1/transactions-excel`;

            let queryParams = [];
            if (filter.search && filter.search !== "") {
                queryParams.push(`search=${filter.search}`);
            }
            if (filter.payment_type && filter.payment_type !== "") {
                queryParams.push(`payment_type=${filter.payment_type}`);
            }

            if (queryParams.length > 0) {
                url += "?" + queryParams.join("&");
            }

            await apiConfig
                .get(url)
                .then((response) => {
                    if (response && response.data && response.data.data && response.data.data.transaction_excel_url) {
                        window.open(
                            response.data.data.transaction_excel_url,
                            "_blank"
                        );
                        dispatch(setLoading(false));
                    }
                })
                .catch(({ response }) => {
                    if (response && response.data) {
                        dispatch(
                            addToast({
                                text: response.data.message,
                                type: toastType.ERROR,
                            })
                        );
                    }
                    dispatch(setLoading(false));
                });
        };
